module.exports = __webpack_public_path__ + "static/img/boss_customerprofile.9557c62b.png";